import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'jira.status.noTransitions': {
    id: 'jira.status.noTransitions',
    defaultMessage: 'No transitions available',
    description: 'Empty state when there are no possible Jira status transitions'
  },
  'jira.status.transitions.non-final': {
    id: 'jira.status.transitions.non-final',
    defaultMessage: 'Change status to',
    description: 'Heading for list of available Jira status transitions'
  }
});
